import {SequenceType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';
import {apiIdToIconName} from 'util/APIUtil';

import {BioentityChipSummaryGraphQL} from '../../../graphql-fragments/registry/registry-items/__generated/BioentityChipSummaryGraphQL';

export function getIconForBioentity(bioentity: BioentityChipSummaryGraphQL): BenchlingIconName | null {
  if (bioentity.tagSchema) {
    return bioentity.tagSchema.iconId as BenchlingIconName;
  } else if (bioentity.__typename === 'SequenceNode') {
    if (bioentity.sequenceType === SequenceType.ds) {
      return FolderItemIcon.Sequence;
    } else if (bioentity.sequenceType === SequenceType.ss) {
      return FolderItemIcon.RNASequence;
    } else {
      return FolderItemIcon.OligoV2;
    }
  } else {
    return apiIdToIconName(bioentity.id);
  }
}
